import React from 'react';
import { bool, shape, string } from 'prop-types';

const Rolling = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 10.7998C17.9971 10.7998 18.4004 11.3373 18.4004 12C18.4003 12.6627 17.997 13.2002 17.5 13.2002C17.003 13.2001 16.6007 12.6626 16.6006 12C16.6006 11.3373 17.003 10.7999 17.5 10.7998Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.5 5C20.1 5 22 8.2 22 12C22 15.8 20.1 19 17.5 19H6.5C3.9 19 2 15.8 2 12C2 8.2 3.9 5 6.5 5H17.5ZM6.5 7C5.3 7 4 9.2 4 12C4 14.8 5.3 17 6.5 17H14.3252C13.4959 15.719 13 13.9381 13 12C13 10.0619 13.4959 8.281 14.3252 7H6.5ZM17.5 7C16.3 7 15 9.2 15 12C15 14.8 16.3 17 17.5 17C18.7 17 20 14.8 20 12C20 9.2 18.7 7 17.5 7Z" fill="currentColor" />
  </svg>
);

Rolling.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Rolling;
